/**
 * @return {string}
 */
module.exports = function getIterableBackendBaseUrl() {
    return window.location.hostname === "itbl.local"
        ? "https://iterable-backend.local"
        : "https://itblapi.wpenginepowered.com";
}